var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSushi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0E0F23",
    d: "M8.153 5.78c.414-.589 1.214-.849 2.249-.765c1.428.12 3.318.9 5.14 2.22c1.814 1.326 3.146 2.906 3.712 4.24c.414.968.427 1.825.013 2.414l-2.842 4.044c-.414.59-1.221.85-2.249.766c-1.428-.127-3.326-.899-5.14-2.226c-1.821-1.32-3.146-2.9-3.719-4.233c-.414-.969-.427-1.826-.013-2.415zm10.721 7.815c.332-.463.263-1.152-.062-1.924c-.545-1.27-1.821-2.766-3.56-4.03c-1.731-1.264-3.532-2.015-4.891-2.127c-.828-.07-1.484.084-1.815.554l-.014.029c-.31.47-.241 1.137.083 1.895c.545 1.278 1.822 2.773 3.553 4.037c1.732 1.264 3.533 2.015 4.892 2.127c.814.064 1.456-.084 1.793-.526zm-4.429-4.809c.87.632 1.51 1.383 1.78 2.022c.159.358.2.674.042.891c-.153.218-.463.281-.842.246c-.683-.056-1.58-.435-2.45-1.067c-.869-.632-1.51-1.376-1.78-2.015c-.151-.358-.193-.674-.04-.892c.15-.217.462-.28.848-.253c.676.064 1.58.436 2.442 1.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.812 11.671c.324.772.393 1.46.062 1.924l-.02.035c-.339.442-.98.59-1.794.527c-1.36-.113-3.16-.864-4.892-2.128S9.16 9.269 8.615 7.992c-.324-.758-.393-1.425-.083-1.895l.014-.029c.331-.47.987-.625 1.815-.554c1.358.112 3.16.863 4.89 2.127c1.74 1.264 3.016 2.76 3.561 4.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSushi0)",
    d: "M19.384 11.813a5 5 0 0 0-.13-.339c-.566-1.333-1.898-2.913-3.712-4.24c-1.821-1.32-3.712-2.099-5.14-2.219c-1.035-.084-1.835.176-2.25.766L5.305 9.825c-.414.59-.4 1.446.013 2.415c.379.881 1.085 1.87 2.046 2.82q.128-.013.255-.041c.513-.116 1.003-.579 1.493-1.04c.63-.594 1.258-1.185 1.922-1.025c.466.105.836.605 1.216 1.118c.16.218.323.438.496.63c.552.65 1.158.933 1.773.8c.702-.14 1.236-.768 1.733-1.475c-1.224-.283-2.676-.972-4.083-1.998c-1.731-1.264-3.008-2.76-3.553-4.037c-.324-.758-.393-1.425-.083-1.895l.014-.029c.332-.47.987-.624 1.815-.554c1.358.112 3.16.863 4.891 2.127c1.736 1.262 3.011 2.755 3.558 4.025l.082.006q.291.033.492.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSushi1)",
    d: "M16.225 10.807c-.27-.638-.911-1.39-1.78-2.022c-.862-.631-1.766-1.003-2.443-1.067c-.386-.028-.696.035-.848.253s-.11.534.041.891c.27.64.91 1.383 1.78 2.015s1.766 1.011 2.45 1.068c.379.035.69-.029.841-.246c.159-.218.117-.534-.041-.892"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.801 7.249a.104.104 0 0 1 .108.1l.006.107a.105.105 0 0 1-.094.113a.104.104 0 0 1-.112-.097l-.007-.114a.105.105 0 0 1 .1-.11m.02.33a.104.104 0 0 1 .119.09c.123.83.583 1.644 1.18 2.395a.107.107 0 0 1-.016.148a.1.1 0 0 1-.146-.016C8.352 9.432 7.866 8.583 7.735 7.7a.105.105 0 0 1 .087-.12m3.06 4.437a.1.1 0 0 1 .11-.032a.1.1 0 0 1 .036.02l.082.072l.102.088a.106.106 0 0 1-.017.174a.1.1 0 0 1-.115-.012l-.105-.09l-.082-.072a.107.107 0 0 1-.011-.149m.395.337a.1.1 0 0 1 .069-.04a.1.1 0 0 1 .076.022a12.4 12.4 0 0 0 2.923 1.694a.105.105 0 0 1 .058.137a.103.103 0 0 1-.135.059a12.6 12.6 0 0 1-2.973-1.724a.107.107 0 0 1-.018-.148m6.574 2.405a.105.105 0 0 1-.086.12l-.139.02a.103.103 0 0 1-.114-.093a.105.105 0 0 1 .09-.116l.13-.018a.1.1 0 0 1 .078.019a.1.1 0 0 1 .041.068"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSushi0",
    x1: 8.875,
    x2: 14.788,
    y1: 5.729,
    y2: 13.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27B0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C26BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSushi1",
    x1: 8.875,
    x2: 14.788,
    y1: 5.728,
    y2: 13.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27B0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C26BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/sushi.d858ed3513eaa2bd0ec30adcb4f6eb20.svg";
export { ForwardRef as ReactComponent };